import { Injectable } from '@angular/core';
import { RestApi } from 'app/auth/rest.api';
import { Observable, Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { BzgToastRef } from 'bz-genome-angular/toast/toast.ref';
import { BzgToastService } from 'bz-genome-angular';
import { ShowToastService } from './showToast.service';
import { I18nService } from 'i18n/i18n.service';

@Injectable()
export class AuthenticationTypeValidationSevice {
    private isAuthenticationValidUrl = 'api/Authentication/IsValid';

    private _toastRef: BzgToastRef = null;
    private _toastActionText = '';

    constructor(private _restApi: RestApi,
        private _toastService: BzgToastService,
        private _translateService: TranslateService,
        private _router: Router,
        private _showToastService: ShowToastService,
        private _i18nService: I18nService) {
    }

    public validate(response: boolean) {
        if(!response && !this._toastRef) {
            this.showMessage();
        } else if(response && this._toastRef) {
            const toastIndex = this._toastService.toastListRefs['top'].toastList.findIndex(toast => toast.action === this._toastActionText);
            if(toastIndex !== -1) {
                this._toastService.toastListRefs['top'].removeFromList(toastIndex);
            }
            this._toastRef = null;
        }
    }

    public forceToCloseToast() {
        if(this._toastRef) {
            const toastIndex = this._toastService.toastListRefs['top'].toastList.findIndex(toast => toast.action === this._toastActionText);
            if(toastIndex !== -1) {
                this._toastService.toastListRefs['top'].removeFromList(toastIndex);
            }
            this._toastRef = null;

        }
    }

    private showMessage() {
        this._showToastService.showToast(this._i18nService.instant('AUTHENTICATION.INVALID_AUTHENTICATION_TYPE'), 'warning');
    }
}
